const notification = {
  'enroll-to-slot-success': 'You are now in queue!',
  'enroll-to-slot-error': 'An error occurred while occupying to slot',
  'sign-off-from-visit-success': 'Slot successfully freed',
  'sign-off-from-visit-error': 'An error occurred while freeing slot'
};

export default notification;
